import { MultiSelect } from "@progress/kendo-react-dropdowns";
import "./FGStyle.css";
import * as tmsCall from "../common/restService/tmServices";
import React, { Component, Fragment, useRef, useState } from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import '@progress/kendo-theme-default/dist/all.css';
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import constants from "../common/restService/constant";
import * as HanaServices from "../common/restService/hanaService";
import * as TmsService from "../common/restService/tmServices";
import GatewayGet from "../common/restService/GatewayGet";
import { Window } from "@progress/kendo-react-dialogs";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import location from "../location.json";
import $, { event } from "jquery";
import { ToastContainer, toast } from "react-toastify";
import kendo from "@progress/kendo-ui";
import "react-toastify/dist/ReactToastify.css";
import { filterBy } from "@progress/kendo-data-query";
import { orderBy } from "@progress/kendo-data-query";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { process } from "@progress/kendo-data-query";
import { count } from "@progress/kendo-data-query/dist/npm/array.operators";
import "../commonStyle/tmsStyle.scss";
import BlockUi from '@availity/block-ui';
import {Circles} from "react-loader-spinner";
import { withRouter } from "../NCRMSHome/withRouter";


const dataState = {
  sort: [],
  take: 25,
  skip: 0,
};

var pickUpStartDate = new Date();
pickUpStartDate.setDate(pickUpStartDate.getDate() - 90);

var pickUpEndDate = new Date();
pickUpEndDate.setDate(pickUpEndDate.getDate() + 90);
//pickUpEndDate = kendo.toString(kendo.parseDate(pickUpEndDate));

var deliveryStartDate = new Date();
deliveryStartDate.setDate(deliveryStartDate.getDate() - 90);
//deliveryStartDate = kendo.toString(kendo.parseDate(deliveryStartDate));

var deliveryEndDate = new Date();
deliveryEndDate.setDate(deliveryEndDate.getDate() + 90);
//deliveryEndDate = kendo.toString(kendo.parseDate(deliveryEndDate));

var FGOrderCreateStartDate = new Date();
FGOrderCreateStartDate.setDate(FGOrderCreateStartDate.getDate() - 90);

var FGOrderCreateEndDate = new Date();
FGOrderCreateEndDate.setDate(FGOrderCreateEndDate.getDate());

class FGNcrmsearch extends React.Component {
  _export;
  _grid;
  export = () => {
    // this._export.save();
    this._export.save();
  };

  constructor(props) {
    super();
    this.state = {
      FGOrderFrmValue: null,
      FGOrderToValue: null,
      checked: false,
      checkedValue: false,
      blocking: false,
      bindFGsearchResult: [],
      dataState: dataState,
      pickUpStartDates: pickUpStartDate,
      pickUpEndDates: pickUpEndDate,
      deliveryStartDates: deliveryStartDate,
      deliveryEndDates: deliveryEndDate,
      FGOrderCreateStartDates: FGOrderCreateStartDate,
      FGOrderCreateEndDates: FGOrderCreateEndDate,
      sourceLocationValue: null,
      destinationLocationvalue: null,
      planOrganisation: [],
      ConversionloadStatus: [],
      ncrmStatusValue: [{ value: "00", text: "00-Staged for NCRM" }],
      //  0013 - IW to X-DOCK
      selectOrderType: [
        { value: "0013", text: "0013 - IW to X-DOCK" },
        { value: "0015", text: "0015 - X-DOCK to Customer" },
        { value: "1013", text: "1013 - 3PL to X-DOCK" },
        { value: "0100", text: "0100 - IW to Customer" },
        { value: "1100", text: "1100 - 3PL to Customer" },
        { value: "OC00", text: "0C00 - IW to Customer" },
        { value: "0C13", text: "0C13 - IW to X-DOCK" },
        { value: "1C00", text: "1C00 - 3PL to Customer" },
        { value: "1C13", text: "1C13 - 3PL to X-DOCK" },
      ],
      planOrganisationValue: [],
      documentData: [],
      FGDeliverynumFrm: null,
      FGDeliverynumTo: null,
      requestnumFrm: null,
      requestnumTo: null,
      STOnumTo: null,
      STOnumFrm: null,
      searchresultContent: false,
      selectedRowData: [],
      checkboxCount: 0,
      checked: false,
      checkedData: [],
    };

    this.FGSearchData = this.FGSearchData.bind(this);
    // this.backbtn=this.backbtn.bind(this);
    this.checkBoxClicked = this.checkBoxClicked.bind(this);
  }

  handleCheck() {
    this.setState({ checked: !this.state.checked });
  }

  FGOrderFromDateChanged = (event) => {
    this.setState({ FGOrderCreateStartDates: event.target.value });
  };

  FGOrderToDateChanged = (event) => {
    this.setState({ FGOrderCreateEndDates: event.target.value });
  };

  ReqPickupFromDateChanged = (event) => {
    this.setState({ pickUpStartDates: event.target.value });
  };

  ReqPickupToDateChanged = (event) => {
    this.setState({ pickUpEndDates: event.target.value });
  };
  ReqDeliveryFrmDateChanged = (event) => {
    this.setState({ deliveryStartDates: event.target.value });
  };
  ReqDeliveryToDateChanged = (event) => {
    this.setState({ deliveryEndDates: event.target.value });
  };

  componentDidMount() {
    $("#searchScreen").show();
    $("#ReportScreen").hide();

    this.loadNCRMStatus();
    this.loadPlanOrg();
    this.OrderTypeData();
  }

  async loadPlanOrg() {
    //
    let props = {};
    let inputObjs = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObjs["Activity"] = "F4_FG_EXEC_ORG_DROPDWN";
    //inputObjs["Input"] = InputJSONString;
    props.input = inputObjs;
    const result = await GatewayGet(props, props.input);

    var planOrg = [...result];

    this.setState({ 
        planOrganisation: planOrg, 
        planOrganisationValue: planOrg
    })
  }

  async OrderTypeData() {
    let props = {};
    let inputObjs = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObjs["Activity"] = "F4_FG_FO_TYPE_DROPDWN";
    //inputObjs["Input"] = InputJSONString;
    props.input = inputObjs;
    const result = await GatewayGet(props, props.input);

    var ncrmStatusData = [];

    for (var i = 0; i < result.length; i++) {
      if (result[i].value) {
        var obj = [];
        obj.text = result[i].value + " - " + result[i].text;
        obj.value = result[i].value;
        ncrmStatusData.push(obj);
      }
    }
    this.setState({ documentData: ncrmStatusData });
  }

  loadNCRMStatus() {
    var ncrmStatus = [];

    var ncrmStatusObj = {};
    ncrmStatusObj["value"] = "00";
    ncrmStatusObj["text"] = "Staged in NCRM";
    ncrmStatus.push(ncrmStatusObj);
    ncrmStatusObj = {};
    ncrmStatusObj["value"] = "10";
    ncrmStatusObj["text"] = "Processed as Intel Ship Req";
    ncrmStatus.push(ncrmStatusObj);
    ncrmStatusObj = {};
    ncrmStatusObj["value"] = "20";
    ncrmStatusObj["text"] = "Processed as Multibid Req";
    ncrmStatus.push(ncrmStatusObj);

    var ncrmStatusData = [];

    for (var i = 0; i < ncrmStatus.length; i++) {
      if (ncrmStatus[i].value) {
        var obj = [];
        obj.text = ncrmStatus[i].value + "-" + ncrmStatus[i].text;
        obj.value = ncrmStatus[i].value;
        ncrmStatusData.push(obj);
      }
      //console.log("dddd",ncrmStatusData);
    }

    this.setState({ ConversionloadStatus: ncrmStatusData });
  }

  async copyData(input) {
    this.setState({ blocking: true });
    let props = {};
    let inputObj = {};
    let InputJSONString = JSON.stringify(input);
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "FG_COPY";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

    const result = await GatewayGet(props, props.input);
    console.log("result", result);
    if (result.STATUS == "SUCCESS") {
      toast.success(
        "NCRM Request#" + "  " + result.DATA + " " + "copied successfully",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        }
      );

      this.FGSearchData();
    }

    this.setState({ checked: false, selectedRowData: [], blocking: false });
    // this.setState({blocking: false});
  }

  copyAsISR() {
    if (this.state.checkedValue == true) {
      this.setState({ blocking: true });
      if (this.state.selectedRowData.length > 1) {
        toast.error(
          "You have selected multiple F.O, Please select one at a time",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          }
        );

        this.setState({ checked: false, selectedRowData: [] });
        this.setState({ blocking: false });
      } else if (this.state.selectedRowData.length == 0) {
        // Please select a record to convert into ISR
        toast.error("Please select a record to convert into ISR", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });

        this.setState({ checked: false, selectedRowData: [], blocking: false });
      } else {
        var selectedValues = [];
        var tor_id = this.state.selectedRowData[0];
        selectedValues = this.state.bindFGsearchResult.filter(function (e) {
          return e.TOR_ID == tor_id;
        });
        //do the copy activity
        if (selectedValues[0].YFG_NCRMSTATUS == "00") {
          //   blockUI.start("Copying......");
          var DatainputObj = {};
          DatainputObj["TOR_ID"] = this.state.selectedRowData[0];
          DatainputObj["TOR_TYPE"] = "ZSSB";
          this.copyData(DatainputObj);
        } else {
          //  angular.element("#notification").getKendoNotification().show("NCRM Request Already Exist", "error");
          //  blockUI.stop();
          toast.error("NCRM Request Already Exist", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          });

          this.setState({
            checked: false,
            selectedRowData: [],
            blocking: false,
          });
          //this.setState({checked:false});
        }
      }
    } else {
      toast.error("Please select a record to convert into ISR", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });

      this.setState({ checked: false, selectedRowData: [], blocking: false });
    }
  }

  copyAsMultiBid() {
    //console.log("selectedRowData",selectedRowData);
    if (this.state.checkedValue == true) {
      this.setState({ blocking: true });
      if (this.state.selectedRowData.length > 1) {
        toast.error(
          "You have selected multiple F.O, Please select one at a time",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          }
        );

        this.state.checkedValue = false;
        this.setState({ checked: false, selectedRowData: [], blocking: false });
      } else if (this.state.selectedRowData.length == 0) {
        // Please select a record to convert into ISR
        toast.error("Please select a record to convert into Multibid", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });

        this.setState({ checked: false, selectedRowData: [], blocking: false });
      } else {
        var selectedValues = [];
        var tor_id = this.state.selectedRowData[0];
        selectedValues = this.state.bindFGsearchResult.filter(function (e) {
          return e.TOR_ID == tor_id;
        });
        //do the copy activity
        if (selectedValues[0].YFG_NCRMSTATUS == "00") {
          //   blockUI.start("Copying......");
          var DatainputObj = {};
          DatainputObj["TOR_ID"] = this.state.selectedRowData[0];
          DatainputObj["TOR_TYPE"] = "ZMSB";

          this.copyData(DatainputObj);
        } else {
          //  angular.element("#notification").getKendoNotification().show("NCRM Request Already Exist", "error");
          //  blockUI.stop();
          toast.error("NCRM Request Already Exist", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          });
        }
      }
    } else {
      toast.error("Please select a record to convert into Multibid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });

      this.setState({ checked: false, selectedRowData: [], blocking: false });
    }
  }

  async FGSearchData() {
    this.setState({ blocking: true });
    toast.dismiss();

    var OrderTypeData = this.state.selectOrderType;

    var DocListItem = [];
    for (var i = 0; i < OrderTypeData.length; i++) {
      if (OrderTypeData[i].value) {
        DocListItem.push(OrderTypeData[i].value);
      }
    }

    //console.log("dddddd",DocListItem);

    var ncrmStatus = this.state.ncrmStatusValue;
    var StatusData = [];
    for (var i = 0; i < ncrmStatus.length; i++) {
      if (ncrmStatus[i].value) {
        StatusData.push(ncrmStatus[i].value);
      }
    }

    //console.log("dddddd",StatusData);

    var PlanningOrg = this.state.planOrganisationValue;

    var PlanOrgData = [];
    for (var i = 0; i < PlanningOrg.length; i++) {
      if (PlanningOrg[i].planOrg) {
        PlanOrgData.push(PlanningOrg[i].planOrg);
      }
    }

    //console.log("dddddd",PlanOrgData);

    var formattedFreightOrderFromDate = "";
    if (
      this.state.FGOrderCreateStartDates != null &&
      this.state.FGOrderCreateStartDates != undefined &&
      this.state.FGOrderCreateStartDates != ""
    ) {
      var d = new Date(this.state.FGOrderCreateStartDates),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      formattedFreightOrderFromDate = [year, month, day].join("");
    }

    var formattedFreightOrderToDate = "";
    if (
      this.state.FGOrderCreateEndDates != null &&
      this.state.FGOrderCreateEndDates != undefined &&
      this.state.FGOrderCreateEndDates != ""
    ) {
      var d = new Date(this.state.FGOrderCreateEndDates),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      formattedFreightOrderToDate = [year, month, day].join("");
    }

    var formattedPickUpFromDate = "";
    if (
      this.state.pickUpStartDates != null &&
      this.state.pickUpStartDates != undefined &&
      this.state.pickUpStartDates != ""
    ) {
      var d = new Date(this.state.pickUpStartDates),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      formattedPickUpFromDate = [year, month, day].join("");
    }

    var formattedPickUpToDate = "";
    if (
      this.state.pickUpEndDates != null &&
      this.state.pickUpEndDates != undefined &&
      this.state.pickUpEndDates != ""
    ) {
      var d = new Date(this.state.pickUpEndDates),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      formattedPickUpToDate = [year, month, day].join("");
    }

    var formattedDeliveryFromDate = "";
    if (
      this.state.deliveryStartDates != null &&
      this.state.deliveryStartDates != undefined &&
      this.state.deliveryStartDates != ""
    ) {
      var d = new Date(this.state.deliveryStartDates),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      formattedDeliveryFromDate = [year, month, day].join("");
    }

    var formattedDeliveryToDate = "";
    if (
      this.state.deliveryEndDates != null &&
      this.state.deliveryEndDates != undefined &&
      this.state.deliveryEndDates != ""
    ) {
      var d = new Date(this.state.deliveryEndDates),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      formattedDeliveryToDate = [year, month, day].join("");
    }

    var inputObj = {};
    inputObj["tor_type"] = DocListItem;
    //inputObj["tor_type"]=["0013","0015","1013","0100","1100"];
    inputObj["exec_org_id"] = PlanOrgData;
    //inputObj["exec_or_id"] = "MY01_PEORG";
    inputObj["tor_id_from"] = this.state.FGOrderFrmValue;
    inputObj["tor_id_to"] = this.state.FGOrderToValue;
    inputObj["created_on_from"] = formattedFreightOrderFromDate;
    inputObj["created_on_to"] = formattedFreightOrderToDate;
    inputObj["yfg_ncrmstatus"] = StatusData;

    inputObj["log_locid_src"] = this.state.sourceLocationValue;
    inputObj["log_locid_des"] = this.state.destinationLocationvalue;
    inputObj["req_start_from"] = formattedPickUpFromDate;
    inputObj["req_start_to"] = formattedPickUpToDate;
    inputObj["req_end_from"] = formattedDeliveryFromDate;
    inputObj["req_end_to"] = formattedDeliveryToDate;
    inputObj["lifnr_from"] = this.state.FGDeliverynumFrm;
    inputObj["lifnr_to"] = this.state.FGDeliverynumTo;
    inputObj["Req_STO_from"] = this.state.STOnumFrm;
    inputObj["Req_STO_to"] = this.state.STOnumTo;
    inputObj["btd_id_from"] = this.state.requestnumFrm;
    inputObj["btd_id_to"] = this.state.requestnumTo;

    let InputJSONString = JSON.stringify(inputObj);
    console.log("InputJSONString", InputJSONString);
    let props = {};
    let inputObjs = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObjs["Activity"] = "FG_WORLIST_BB";
    inputObjs["Input"] = InputJSONString;
    props.input = inputObjs;
    const result = await GatewayGet(props, props.input);
    const searchresult = result.DATA;

    this.state.searchresultContent = true;

    if (searchresult != undefined) {
      $("#searchScreen").hide();
      $("#ReportScreen").show();
      //  this.setState({blocking:!this.state.blocking});
      console.log("searchresult", searchresult);
      this.setState({ bindFGsearchResult: searchresult });
    }

    this.setState({ blocking: false });
  }

  handleOrderTypeChange = (event) => {
    this.setState({ selectOrderType: event.target.value });
  };

  FGOrderNumberFrm = (event) => {
    this.setState({ FGOrderFrmValue: event.target.value });

    //const FGorderFrom=event.target.value;
    var regexPattern = /^[0-9,]+$/i;
    var regexResult = event.target.value.match(regexPattern);
    if (regexResult == null || regexResult == "") {
      //angular.element("#notification").getKendoNotification().show("", "error");
      const errormsg =
        "Freight Order number can contain Numbers and Special Character Comma(,) only";

      toast.error(errormsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
      this.setState({ FGOrderFrmValue: "" });
      return;
    }
  };
  FGOrderNumberTo = (event) => {
    this.setState({ FGOrderToValue: event.target.value });

    const FGorderTo = event.target.value;
    var regexPattern = /^[0-9,]+$/i;
    var regexResult = event.target.value.match(regexPattern);
    if (regexResult == null || regexResult == "") {
      const errormsg =
        "Freight Order number can contain Numbers and Special Character Comma(,) only";
      toast.error(errormsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
      this.setState({ FGOrderToValue: "" });
      return;
    }

    //  this.setState({blocking:false});
  };

  FGconverChanged = (event) => {
    this.setState({ ncrmStatusValue: event.target.value });
  };

  handleOrganChanged = (event) => {
    this.setState({ planOrganisationValue: event.target.value });
  };

  sourcechanged = (event) => {
    this.setState({ sourceLocationValue: event.target.value });

    const sourceLoc = event.target.value;
    var regexPattern = /^[A-Za-z0-9,]+$/i;
    var regexResult = sourceLoc.match(regexPattern);
    if (regexResult == null || regexResult == "") {
      //angular.element("#notification").getKendoNotification().show("", "error");
      const errormsg =
        "Source Location can contain alphabets Numbers and Special Character Comma(,) only";

      toast.error(errormsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
      this.setState({ sourceLocationValue: "" });
      return;
    }
  };

  destinationChanged = (event) => {
    this.setState({ destinationLocationvalue: event.target.value });
    const DestinationLoc = event.target.value;
    var regexPattern = /^[A-Za-z0-9,]+$/i;
    var regexResult = DestinationLoc.match(regexPattern);
    if (regexResult == null || regexResult == "") {
      //angular.element("#notification").getKendoNotification().show("", "error");
      const errormsg =
        "Destination Location can contain alphabets Numbers and Special Character Comma(,) only";

      toast.error(errormsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });

      this.setState({ destinationLocationvalue: "" });

      return;
    }
  };

  FGdeliveryChangedTo = (event) => {
    this.setState({ FGDeliverynumTo: event.target.value });

    var deltimeTo = event.target.value;
    var regexPattern = /^[0-9,]+$/i;
    var regexResult = deltimeTo.match(regexPattern);
    if (regexResult == null || regexResult == "") {
      const errmsg =
        "Delivery Number can contain  Numbers and Special Character Comma(,) only";

      toast.error(errmsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });

      return;
    }
  };

  FGdeliveryChangedFrm = (event) => {
    this.setState({ FGDeliverynumFrm: event.target.value });

    const delTime = event.target.value;

    var regexPattern = /^[0-9,]+$/i;
    var regexResult = delTime.match(regexPattern);

    if (regexResult == null || regexResult == "") {
      const errmsg =
        "Delivery Number can contain  Numbers and Special Character Comma(,) only";

      toast.error(errmsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
      this.setState({ FGDeliverynumFrm: "" });
      return;
    }
  };

  requestChangedFrm = (event) => {
    this.setState({ requestnumFrm: event.target.value });

    const requestnumFrm = event.target.value;
    var regexPattern = /^[0-9,]+$/i;
    var regexResult = requestnumFrm.match(regexPattern);

    if (regexResult == null || regexResult == "") {
      const errmsg =
        "NCRM Request Number can contain  Numbers and Special Character Comma(,) only";

      toast.error(errmsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
      this.setState({ requestnumFrm: "" });
      return;
    }
  };

  requestChangedTo = (event) => {
    this.setState({ requestnumTo: event.target.value });

    const requestnumTo = event.target.value;
    var regexPattern = /^[0-9,]+$/i;
    var regexResult = requestnumTo.match(regexPattern);

    if (regexResult == null || regexResult == "") {
      const errmsg =
        "NCRM Request Number can contain  Numbers and Special Character Comma(,) only";

      toast.error(errmsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
      this.setState({ requestnumTo: "" });
      return;
    }
  };
  stonumchangedto = (event) => {
    this.setState({ STOnumTo: event.target.value });

    const STOTO = event.target.value;

    var regexPattern = /^[0-9,]+$/i;
    var regexResult = STOTO.match(regexPattern);

    if (regexResult == null || regexResult == "") {
      const errmsg =
        "STO Number can contain  Numbers and Special Character Comma(,) only";

      toast.error(errmsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
      this.setState({ STOnumTo: "" });
      return;
    }
  };
  stonumchangedfrm = (event) => {
    this.setState({ STOnumFrm: event.target.value });

    // this.setState({FGDeliverynumFrm:event.target.value});

    const STOFrm = event.target.value;

    var regexPattern = /^[0-9,]+$/i;
    var regexResult = STOFrm.match(regexPattern);

    if (regexResult == null || regexResult == "") {
      const errmsg =
        "STO Number can contain  Numbers and Special Character Comma(,) only";

      toast.error(errmsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
      this.setState({ STOnumFrm: "" });
      return;
    }
  };

  backbtn = () => {
    toast.dismiss();
    this.setState({ blocking: true });
    setTimeout(() => {
      this.setState({ blocking: false });
      $("#searchScreen").show();
      $("#ReportScreen").hide();
    }, 3000);
  };

  checkBoxClicked(data, e) {
    //this.setState({checked: !this.state.checked});

    this.state.checkedValue = e.target.checked;

    console.log("checked Data", data, e.target.checked);
    //const selectrow=[];
    if (e.target.checked == true) {
      //selectrow.push(data.dataItem.TOR_ID);
      this.state.selectedRowData.push(data.dataItem.TOR_ID);
      //this.state.selectedRowData=selectrow;
    } else {
      var toDel = this.state.selectedRowData.indexOf(data.dataItem.TOR_ID);
      this.state.selectedRowData.splice(toDel, 1);
      e.target.checked = false;
    }
    //this.state.selectedRowData.push(dataItem.dataItem);
    // this.copyAsMultiBid(this.state.selectedRowData);
  }
  onButtonClick(e) {
   
    this.props.navigate('/intelshipment',{ state: {FGsearchScreenData:e,isFGType: true}})
 
  }
  render() {
    const grid = (
      <Grid
        width="100%"
        pageable
        sortable
        filterable
        data={process(this.state.bindFGsearchResult, this.state.dataState)}
        {...this.state.dataState}
        onDataStateChange={(e) => {
          this.setState({ dataState: e.dataState });
        }}
        dataGrid="myGrid"
        dataBound={this.onDataBound}
        reorderable
        ref={(grid) => {
          this._grid = grid;
        }}
      >
        {/* _checkboxtemplate = '', */}
        {/* cell={ props=>(<td className="customTd"><input type="checkbox" defaultChecked={this.state.checked} onChange= {this.checkBoxClicked.bind(this,props)} /></td>)} */}
        <GridColumn
          locked={true}
          filterable={false}
          field=""
          title=""
          width="50px"
          cell={(props) => (
            <td
              className="k-grid-content-sticky"
              role="gridcell"
              aria-colindex="1"
              style={{ left: "0px", right: "0px" }}
            >
              <input
                type="checkbox"
                defaultChecked={this.state.checked}
                onChange={this.checkBoxClicked.bind(this, props)}
              />
            </td>
          )}
        />
        <GridColumn
          locked={true}
          field="TOR_TYPE"
          title="Document Type"
          width="150px"
          filter="text"
        />
        <GridColumn
          locked={true}
          field="TOR_ID"
          title="Freight Order Number"
          filter="text"
          width="150px"
        />
        <GridColumn
          field="LOG_LOCID_SRC"
          title="Source Location"
          filter="text"
          width="150px"
        />
        <GridColumn
          field="LOG_LOCID_DES"
          title="Destination Location"
          filter="text"
          width="150px"
        />
        <GridColumn
          field="DESCR40"
          title="Destination Location Description"
          filter="text"
          width="150px"
        />
        <GridColumn
          field="REQ_START"
          title="Pick Up Date"
          filter="text"
          width="150px"
        />
        <GridColumn
          field="REQ_END"
          title="Delivery Date"
          filter="text"
          width="150px"
        ></GridColumn>
        <GridColumn
          field="GRO_WEI_VAL"
          title="Gross Weight"
          filter="text"
          width="150px"
        />
        <GridColumn
          field="GRO_WEI_UNI"
          title="UOM"
          filter="text"
          width="150px"
        />
        <GridColumn
          field="LIFNR"
          title="Delivery Number"
          filter="text"
          width="109px"
          className="delivery-number"
        />
        <GridColumn
          field="VBELN"
          title="SO/STO Number"
          filter="text"
          width="150px"
        />

        <GridColumn
          field="NCRM_REQ"
          title="NCRM Request Number"
          width="150px"
          filter="text"
          cell={(props) => (
            <td style={{cursor:"pointer",color:"#6495ed"}} onClick={() => this.onButtonClick(props.dataItem)}>

                {props.dataItem.NCRM_REQ}
            </td>
          )}
        />

        <GridColumn
          field="NCRM_REQ_TYPE"
          title="NCRM Request Type"
          filter="text"
          width="150px"
        />
        <GridColumn
          field="YTOR_DOCSTATUS"
          title="NCRM Request Status"
          filter="text"
          width="150px"
        />
      </Grid>
    );

    return (
      <div>
        <div id="searchScreen" style={{marginTop:"-4px"}}>
          <BlockUi 
            tag="div"
            blocking={this.state.blocking}
            loader={
              <Circles
              color="#00BFFF"
              height="100"
              width="100"
              timeout="6000" //3 secs
          />
            }
          >
            {/* <ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
width="auto"
>
</ToastContainer> */}

            <MDBContainer fluid>
              <MDBRow>
                <MDBCol sm="12" className="titleBox">
                  <label>Staged FG Freight Orders</label>
                </MDBCol>
              </MDBRow>
              {/* <MDBRow>
    <MDBCol sm="12" className="subtitl"><label><b>Report Selection Parameters </b></label></MDBCol>
    </MDBRow> */}
              {/* 
    <MDBRow>
        <MDBCol><p className=""></p></MDBCol>
    </MDBRow> */}
            </MDBContainer>

            <MDBContainer fluid>
              <h6 className="titleFG" style={{ margin: "25px 0px 0px 0px" }}>
                Header Section
                <span className="btnsea">
                  <button
                    type="submit"
                    onClick={this.FGSearchData}
                    className="btn k-button k-button-icontext"
                  >
                    Search
                  </button>
                </span>
              </h6>

              <br />
              <br />

              <MDBRow>
                <MDBCol md="2">
                  <label className="LabelFGClass">
                    FG Freight Order Type <em>*</em>
                  </label>
                </MDBCol>
                <MDBCol md="7">
                  <MultiSelect
                    data={this.state.documentData}
                    value={this.state.selectOrderType}
                    dataItemKey="value"
                    textField="text"
                    onChange={this.handleOrderTypeChange}
                  ></MultiSelect>
                </MDBCol>
              </MDBRow>
              <br></br>
              <MDBRow>
                <MDBCol md="2">
                  <label className="LabelFGClass">FG Freight Order Number</label>
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="text"
                    value={this.state.FGOrderFrmValue}
                    onChange={this.FGOrderNumberFrm}
                    placeholder="Request ID From"
                    className="form-control FGtxt"
                  ></input>
                </MDBCol>
                <MDBCol md="1">
                  <label className="LabelFGClass">To</label>
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="text"
                    value={this.state.FGOrderToValue}
                    onChange={this.FGOrderNumberTo}
                    placeholder="Request ID To"
                    className="form-control FGtxt"
                  ></input>
                </MDBCol>
              </MDBRow>

              <br></br>
              <MDBRow>
                <MDBCol md="2">
                  <label className="LabelFGClass">FG Freight Order Created Date</label>
                </MDBCol>
                <MDBCol md="3">
                  <DatePicker
                    onChange={this.FGOrderFromDateChanged}
                    value={this.state.FGOrderCreateStartDates}
                  ></DatePicker>
                </MDBCol>
                <MDBCol md="1">
                  <label className="LabelFGClass">To</label>
                </MDBCol>
                <MDBCol md="3">
                  <DatePicker
                    value={this.state.FGOrderCreateEndDates}
                    onChange={this.FGOrderToDateChanged}
                  ></DatePicker>
                </MDBCol>
              </MDBRow>

              <br></br>
              <MDBRow>
                <MDBCol md="2">
                  <label className="LabelFGClass">FG FO Conversion Status</label>
                </MDBCol>
                <MDBCol md="7">
                  <MultiSelect
                    data={this.state.ConversionloadStatus}
                    value={this.state.ncrmStatusValue}
                    dataItemKey="value"
                    textField="text"
                    onChange={this.FGconverChanged}
                  ></MultiSelect>
                </MDBCol>
              </MDBRow>
              <br />
              <br />
            </MDBContainer>
            <MDBContainer fluid>
              <h6 className="titleFG">Location Selection</h6>
              <br />
              <br />
              <MDBRow>
                <MDBCol md="2">
                  <label className="LabelFGClass">Planning Organisation</label>
                </MDBCol>
                <MDBCol md="7">
                  <MultiSelect
                    data={this.state.planOrganisation}
                    value={this.state.planOrganisationValue}
                    dataItemKey="value"
                    textField="value"
                    onChange={this.handleOrganChanged}
                  ></MultiSelect>
                </MDBCol>
              </MDBRow>
              <br />
              <MDBRow>
                <MDBCol md="2">
                  <label className="LabelFGClass">Source Location</label>
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="text"
                    placeholder="Source Location"
                    value={this.state.sourceLocationValue}
                    onChange={this.sourcechanged}
                    className="form-control FGtxt"
                  ></input>
                </MDBCol>
              </MDBRow>
              <br />
              <MDBRow>
                <MDBCol md="2">
                  <label className="LabelFGClass">Destination Location</label>
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="text"
                    value={this.state.destinationLocationvalue}
                    onChange={this.destinationChanged}
                    placeholder="Destination Location"
                    className="form-control FGtxt"
                  ></input>
                </MDBCol>
              </MDBRow>
              <br />
              <MDBRow>
                <MDBCol md="2">
                  <label className="LabelFGClass">Requested PickUp Date</label>
                </MDBCol>
                <MDBCol md="3">
                  <DatePicker
                    onChange={this.ReqPickupFromDateChanged}
                    value={this.state.pickUpStartDates}
                  ></DatePicker>
                </MDBCol>
                <MDBCol md="1">
                  <label className="LabelFGClass">To</label>
                </MDBCol>
                <MDBCol md="3">
                  <DatePicker
                    onChange={this.ReqPickupToDateChanged}
                    value={this.state.pickUpEndDates}
                  ></DatePicker>
                </MDBCol>
              </MDBRow>
              <br />
              <MDBRow>
                <MDBCol md="2">
                  <label className="LabelFGClass">Requested Delivery Date</label>
                </MDBCol>
                <MDBCol md="3">
                  <DatePicker
                    onChange={this.ReqDeliveryFrmDateChanged}
                    value={this.state.deliveryStartDates}
                    style={{ width: "100%" }}
                  ></DatePicker>
                </MDBCol>
                <MDBCol md="1">
                  <label className="LabelFGClass">To</label>
                </MDBCol>
                <MDBCol md="3">
                  <DatePicker
                    onChange={this.ReqDeliveryToDateChanged}
                    value={this.state.deliveryEndDates}
                    style={{ width: "100%" }}
                  ></DatePicker>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
            <br />
            <MDBContainer fluid>
              <h6 className="titleFG">Reference Doc Selection</h6>
              <br />
              <br />

              <MDBRow>
                <MDBCol md="2">
                  <label className="LabelFGClass">FG Delivery Number</label>
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="text"
                    value={this.state.FGDeliverynumFrm}
                    onChange={this.FGdeliveryChangedFrm}
                    placeholder="Delivery Number"
                    className="form-control FGtxt"
                  ></input>
                </MDBCol>
                <MDBCol md="1">
                  <label className="LabelFGClass">To</label>
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="text"
                    value={this.state.FGDeliverynumTo}
                    onChange={this.FGdeliveryChangedTo}
                    placeholder="Delivery Number"
                    className="form-control FGtxt"
                  ></input>
                </MDBCol>
              </MDBRow>
              <br />
              <MDBRow>
                <MDBCol md="2">
                  <label className="LabelFGClass">SO/STO Number</label>
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="text"
                    value={this.state.STOnumFrm}
                    onChange={this.stonumchangedfrm}
                    placeholder="SO/STO Number"
                    className="form-control FGtxt"
                  ></input>
                </MDBCol>
                <MDBCol md="1">
                  <label className="LabelFGClass">To</label>
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="text"
                    value={this.state.STOnumTo}
                    onChange={this.stonumchangedto}
                    placeholder="SO/STO Number"
                    className="form-control FGtxt"
                  ></input>
                </MDBCol>
              </MDBRow>

              <br />
              <MDBRow>
                <MDBCol md="2">
                  <label className="LabelFGClass">NCRM Request Number</label>
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="text"
                    value={this.state.requestnumFrm}
                    onChange={this.requestChangedFrm}
                    placeholder="NCRM Request Number"
                    className="form-control FGtxt"
                  ></input>
                </MDBCol>
                <MDBCol md="1">
                  <label className="LabelFGClass">To</label>
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="text"
                    value={this.state.requestnumTo}
                    onChange={this.requestChangedTo}
                    placeholder="NCRM Request Number"
                    className="form-control FGtxt"
                  ></input>
                </MDBCol>
              </MDBRow>
            </MDBContainer>

            <br></br>
            <br></br>
            <br></br>

            <br />
            <br />
          </BlockUi>
        </div>

        <div id="ReportScreen">
          <BlockUi tag="div" blocking={this.state.blocking}>
            {/* <ToastContainer 
position="top-right"
autoClose={3000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
width="500px"
/>
<ToastContainer /> */}

            <MDBContainer fluid>
              <MDBRow>
                <MDBCol sm="12" className="titleBox">
                  <label>Staged FG Freight Orders List</label>
                </MDBCol>
                {/* <MDBCol sm="12"><label><b>NCRM Report </b></label></MDBCol> */}
              </MDBRow>
              {/* <MDBRow>
        <MDBCol sm="12" className="subtitl" style={{textAlign:'center'}}><label><b>Report Generation</b></label></MDBCol>
    </MDBRow> */}
            </MDBContainer>

            <MDBContainer fluid className="bxcontent">
              <MDBRow>
                <div className="FgButton">
                  <button
                    className="btn k-button k-button-icontext reset"
                    style={{width:"75px"}}
                    onClick={this.backbtn.bind(this)}
                  >
                    Back
                  </button>
                  <button
                    className="btn k-button k-button-icontext"
                    style={{width:"179px"}}
                    onClick={this.copyAsISR.bind(this)}
                  >
                    Copy Selected as ISR
                  </button>
                  <button
                    className="btn k-button k-button-icontext"
                    style={{width:"200px"}}
                    onClick={this.copyAsMultiBid.bind(this)}
                  >
                    Copy Selected as Multi Bid
                  </button>
                  <button
                    className="btn k-button k-button-icontext"
                    style={{width:"115px"}}
                    onClick={this.export}
                  >
                    Export to Excel
                  </button>
                </div>
              </MDBRow>
            </MDBContainer>
            <MDBContainer fluid>
              <MDBRow>
                <MDBCol md="12">
                  {this.state.searchresultContent && (
                    <div className="FgDiv">{grid}</div>
                  )}

                  <ExcelExport
                    data={this.state.bindFGsearchResult}
                    ref={(exporter) => {
                      this._export = exporter;
                    }}
                    fileName={"FG FO LIST FOR NCRM.xlsx"}
                  >
                    <ExcelExportColumn
                      field="TOR_TYPE"
                      title=""
                      filter="text"
                    />
                    <ExcelExportColumn
                      field="TOR_TYPE"
                      title="Document Type"
                      width="150px"
                    ></ExcelExportColumn>
                    <ExcelExportColumn
                      field="TOR_ID"
                      title="Freight Order Number"
                      filter="text"
                      width="150px"
                    ></ExcelExportColumn>
                    <ExcelExportColumn
                      field="LOG_LOCID_SRC"
                      title="Source Location"
                      filter="text"
                      width="150px"
                    ></ExcelExportColumn>
                    <ExcelExportColumn
                      field="LOG_LOCID_DES"
                      title="Destination Location"
                      filter="text"
                      width="150px"
                    ></ExcelExportColumn>
                    <ExcelExportColumn
                      field="DESCR40"
                      title="Destination Location Description"
                      filter="text"
                      width="150px"
                    />
                    <ExcelExportColumn
                      field="REQ_START"
                      title="Pick Up Date"
                      filter="text"
                      width="150px"
                    />
                    <ExcelExportColumn
                      field="REQ_END"
                      title="Delivery Date"
                      filter="text"
                      width="150px"
                    />
                    <ExcelExportColumn
                      field="GRO_WEI_VAL"
                      title="Gross Weight"
                      filter="text"
                      width="150px"
                    />
                    <ExcelExportColumn
                      field="GRO_WEI_UNI"
                      title="UOM"
                      filter="text"
                      width="150px"
                    />
                    <ExcelExportColumn
                      field="LIFNR"
                      title="Delivery Number"
                      filter="text"
                      width="150px"
                    />
                    <ExcelExportColumn
                      field="VBELN"
                      title="SO/STO Number"
                      filter="text"
                      width="150px"
                    />
                    <ExcelExportColumn
                      field="NCRM_REQ"
                      title="NCRM Request Number"
                      filter="text"
                      width="150px"
                    />
                    <ExcelExportColumn
                      field="NCRM_REQ_TYPE"
                      title="NCRM Request Type"
                      filter="text"
                      width="150px"
                    />
                    <ExcelExportColumn
                      field="YTOR_DOCSTATUS"
                      title="NCRM Request Status"
                      filter="text"
                      width="150px"
                    />
                  </ExcelExport>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </BlockUi>
        </div>
      </div>
    );
  }
}
export default withRouter(FGNcrmsearch);